module.exports = __webpack_public_path__ + "static/media/photo288.a88ae163.jpg";